import * as ActionTypes from '../../actions/ActionTypes';
import ImportWarningRecord from '../../records/import/ImportWarningRecord';
const INITIAL_STATE = new ImportWarningRecord();
export default function importWarning(state = INITIAL_STATE, {
  error,
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_IMPORT_WARNING_AND_DOWNLOAD_LINK_PENDING:
      return state.merge({
        isRequesting: true,
        error: undefined
      });
    case ActionTypes.FETCH_IMPORT_WARNING_AND_DOWNLOAD_LINK_SUCCESS:
      return state.merge({
        isRequesting: false,
        error: undefined,
        lastLoaded: new Date().valueOf()
      }).set('alteredArticlesListLink', payload.alteredArticlesListLink).set('count', payload.count);
    case ActionTypes.FETCH_IMPORT_WARNING_AND_DOWNLOAD_LINK_ERROR:
      return state.merge({
        isRequesting: false,
        error
      });
    case ActionTypes.RESET_IMPORT_WARNING_AND_DOWNLOAD_LINK:
      return INITIAL_STATE;
    default:
      return state;
  }
}